<!--
  --
  -- 住所入力 コンポーネント
  --
  -->
<template>
  <div>
    <!-- 郵便番号 -->
    <v-text-field
      class="max-w-xs"
      label="郵便番号"
      type="text"
      v-model="form.postal"
      :rules="[rule.required('郵便番号'), rule.postal]"
      @input="onChangePostal"
    />

    <!-- 住所1 -->
    <v-combobox
      label="住所"
      type="text"
      v-model="form.address1"
      :rules="[rule.required('住所'), rule.address]"
      :items="areas"
      hide-no-data
    />

    <!-- 住所2 -->
    <v-text-field
      label="番地・マンションなど"
      type="text"
      v-model="form.address2"
      :rules="[rule.address]"
    />
  </div>
</template>

<script>
import * as http from '@/libs/http'

export default {
  name: 'CProfileAddress',
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    areas: []
  }),
  methods: {
    async onChangePostal () {
      // 郵便番号 7 桁が入力されたか
      if (!(/^\d{3}-?\d{4}$/.test(this.form.postal))) {
        this.areas = []
        return
      }

      // TODO: 郵便番号検索
      const resp = { status: http.NotFound, data: [] }

      // 該当する郵便番号がない
      if (resp.status !== http.OK) {
        this.areas = []
        return
      }

      // this.areas を更新する
      this.areas = resp.data.map(item => item.address)

      // 1件だけなら自動入力する
      if (this.areas.length === 1) {
        this.form.address1 = this.areas[0]
      }
    }
  }
}
</script>
